import React from 'react';
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Legend
} from 'recharts';

import { answerColorDict } from '../../../resources/thematic-topics';

const COLORS = ['#8c510a','#d8b365','#c7eae5','#5ab4ac','#01665e'];

function makeRandomColor(index){
  return COLORS[index%COLORS.length];
}

function makeFill(keyName, index){
  return answerColorDict[keyName] || makeRandomColor(index);
}

class SelectView extends React.PureComponent {
  renderCells(data) {
    return data.map((keyName, index) => {
      return (
        <Cell key={index}
          fill={ makeFill(keyName.name, index) }
        />
      );
    });
  }

  render() {
    const data = this.props.data;

    return (
      <ResponsiveContainer width="100%" height={180}>
        <PieChart>
          <Legend layout="vertical" align="left" iconSize={10} />
          <Pie
            tooltip
            label
            labelLine
            data={data}
            cx={ '55%' }
            cy={ '55%' }
            innerRadius={30}
            outerRadius={60}
            fill="#8884d8"
            paddingAngle={1}
          >
            { this.renderCells(data) }
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    );
  }
}

export default SelectView;



// WEBPACK FOOTER //
// ./src/components/Statistics/Views/SelectView.js